// This file is a proxy that imports the correct runtime config
// based on the build environment. Webpack DefinePlugin will inject NODE_ENV
// at build time so we can use it here.

// Note: We use a simple approach - just set a global NODE_ENV if not set
if (typeof process === 'undefined') {
	global.process = { env: {} }
}

// Determine which config file to load based on something available at build time
// Since webpack processes this, we can use conditional requires
let config

// Runtime config (tokens, SSO, AWS, etc.) is selected by NODE_ENV.
// URLs inside each *_runtime.js come from urls_config.js which uses ENV_URLS.
// So dev:prod = dev_runtime (staging auth) + prod URLs (via ENV_URLS=production)
switch (process.env.NODE_ENV) {
case 'production':
  config = require('./prod_runtime.js')
  break
case 'local':
  config = require('./local_runtime.js')
  break
default:
  // staging/development use dev_runtime
  config = require('./dev_runtime.js')
  break
}

module.exports = config



//////////////////
// WEBPACK FOOTER
// ./config/runtime_config.js
// module id = 9f/w
// module chunks = 55